import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CollectionManagerService, EntityService } from '@zerops/zef/entities';
import { ApiEntityKeys, AppState } from '@zerops/zerops/app';
import { ZefWebsocketService } from '@zerops/zef/websocket';
import { FreeResourceSummary } from '@zerops/models/free-resource-summary';

@Injectable({ providedIn: 'root' })
export class FreeResourceSummaryEntity extends EntityService<FreeResourceSummary> {
  constructor(
    public store: Store<AppState>,
    public collectionManager: CollectionManagerService,
    public websocketService: ZefWebsocketService
  ) {
    super(ApiEntityKeys.FreeResourceSummary, store, collectionManager, websocketService);
  }
}
